<template>
  <v-dialog
    v-model="internalIsOpened"
    class="Modal"
    content-class="Modal"
    :maxWidth="maxWidth"
    :scrollable="isScrollable"
    persistent
  >
    <img
      class="Modal_closeBox"
      alt="close modal"
      :src="closeBoxSrc"
      @click="internalIsOpened = false"
    />

    <slot />
  </v-dialog>
</template>

<script>
  import { MODAL_CLOSE_BOX_THEMES } from '@/components/ui/common/Modal/Modal.const'

  export default {
    props: {
      isOpened: {
        type: Boolean,
        default: false,
      },
      maxWidth: {
        type: [String, Number,],
        default: 1371,
      },
      closeBoxTheme: {
        type: String,
        default: MODAL_CLOSE_BOX_THEMES.light,
      },
      isScrollable: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      closeBoxSrc() {
        if (this.closeBoxTheme === MODAL_CLOSE_BOX_THEMES.light) {
          return './assets/icons/close-white.svg'
        }

        return './assets/icons/close.svg'
      },
      internalIsOpened: {
        get() {
          return this.isOpened
        },
        set(isOpened) {
          if (!isOpened) {
            this.$emit('close')
          }
        },
      },
    },
  }
</script>

<style lang="scss">
.Modal {
  position: relative;

  &_closeBox {
    position: absolute;
    top: 0;
    right: 0;
    width: 48px;
    height: 48px;
    z-index: $zIndexModelCloseBox;
    cursor: pointer;
  }
}
</style>
